import * as XLSX from "xlsx";

export class CsvExporter {
  static exportToXlsx(
    options: {
      fileName: string;
      sheet: string;
      Props: { Author: string };
    },
    rows: Object[]
  ): void {
    const {
      fileName,
      sheet,
      Props: { Author },
    } = options;

    if (!rows || !rows.length) {
      console.warn("No data to export.");
      return;
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Add metadata like author
    const workbook = XLSX.utils.book_new();
    workbook.Props = {
      Author: Author,
      CreatedDate: new Date(),
    };

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet);

    // Write the file as an xlsx
    const fileNameWithExtension = `${fileName}_${sheet}.xlsx`;
    XLSX.writeFile(workbook, fileNameWithExtension);
  }
}
